module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ZrPWr"))).then(() => module.bundle.root('hEqeo'));